/** @jsxImportSource @emotion/react */
import { Theme, css } from "@emotion/react";
import styled, { Interpolation } from "@emotion/styled";
import { useRecoilState, useRecoilValue } from "recoil";
import { util } from "recoil/recoilState";
import { theme } from "styles/theme";

const BtnContainer = styled.div`
    display: flex;
    padding: 9px 25px;
    align-items: center;
    gap: 10px;
    background-color: #f7f8f9;
`;

const Label = styled.p`
    color: ${theme.neutral600};
    font-size: 26px;
    font-weight: 500;
`;

type TTranslation = {
    styles?: {
        container?: Interpolation<Theme>;
        text?: Interpolation<Theme>;
    };
    iconSize?: number;
    allowClick?: boolean;
};

const TranslationBtn = (props: TTranslation) => {
    const { styles, iconSize = 40, allowClick = false } = props;
    const { language } = useRecoilValue(util);
    const [utils, setUtils] = useRecoilState(util);

    return (
        <BtnContainer
            css={[styles?.container]}
            onClick={() => {
                if (allowClick) {
                    if (language === "ko")
                        setUtils((prev) => {
                            return { ...prev, language: "en" };
                        });
                    else {
                        setUtils((prev) => {
                            return { ...prev, language: "ko" };
                        });
                    }
                }
            }}
        >
            <TranslationIcon size={iconSize} />
            <Label css={[styles?.text]}>translation</Label>
        </BtnContainer>
    );
};

const TranslationIcon = ({ size }: { size: number }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.48486" y="3.48535" width="22.6515" height="22.6515" rx="6.36364" fill="#D6DEE8" />
            <path
                d="M19.0013 9.18868V13.8166H20.5904V15.6008H19.0013V21.7341H16.7989V9.18868H19.0013ZM8.68615 18.0541C11.474 16.6323 12.9655 14.862 13.328 12.1996H9.46675V10.4432H15.5722C15.5443 14.3184 14.2201 17.5941 9.91282 19.699L8.68615 18.0541Z"
                fill="#454C53"
            />
            <rect x="13.9395" y="13.9399" width="24.3939" height="24.3939" rx="7.27273" fill="#3885FF" />
            <path
                d="M23.1209 32.5H20.3679L24.6194 20.1636H27.93L32.1815 32.5H29.4285L28.505 29.6773H24.0444L23.1209 32.5ZM24.6891 27.6561H27.8603L26.327 22.9515H26.2224L24.6891 27.6561Z"
                fill="white"
            />
        </svg>
    );
};

export default TranslationBtn;
